import { useSelector } from "react-redux"
import { Link } from "react-router";
import { Sparkle, ShoppingCart } from "lucide-react"
import { BRAND_NAME } from "../utils/config"


export default function RestHeader(){

    const counter = useSelector(state=> state.cartslice.count);

    return (
        <div className="w-full bg-charcoal py-5 px-8 flex justify-between items-center font-body">
            <Link to="/" className="flex items-center gap-2 text-cream">
                <Sparkle className="w-6 h-6 text-turmeric" fill="currentColor" />
                <span className="font-display text-2xl font-semibold tracking-tight">{BRAND_NAME}</span>
            </Link>
            <Link to="/Checkout" className="flex items-center gap-2 text-cream text-lg font-medium border border-cream/30 py-2 px-5 rounded-full hover:bg-cream/10 transition">
                <ShoppingCart className="w-5 h-5" />
                Cart <span className="font-mono text-turmeric">({counter})</span>
            </Link>
        </div>
    )
}